import {
  APIConfiguration,
  Service,
  SWRConfiguration,
  useList,
  useListWithCount,
  useRead,
} from "@api/common";
import type { ListParams, ReadParams } from "./types";
import { FlowState, FlowStateWithFlow } from "./types/flow-state";
import { getParamsWithPagination } from "./utils";

export class FlowStateService extends Service<FlowState> {
  constructor() {
    super("/flow-states");
  }
}

export const flowStateService = new FlowStateService();

export function useFlowStates(params?: ListParams<FlowState>, config?: SWRConfiguration) {
  return useList(flowStateService, params, config);
}

export function useFlowStatesWithCount(params?: ListParams<FlowState>, config?: SWRConfiguration) {
  return useListWithCount(
    flowStateService,
    {
      ...getParamsWithPagination(params),
      populate: "customer(firstName,lastName,phoneNumber)",
    },
    config,
  );
}

export function useFlowState(id?: string, params?: ReadParams, config?: SWRConfiguration) {
  return useRead(flowStateService, id, params, config);
}

/**
 * Hook to fetch flow states for a specific customer with populated flow data.
 * Used in the contact sidebar to show which flows a customer is currently in.
 */
export function useCustomerFlowStates(
  params?: { gym: string; customer: string; status?: string },
  config?: APIConfiguration,
) {
  return useList(
    flowStateService as unknown as Service<FlowStateWithFlow>,
    params
      ? {
          ...params,
          populate: "flow(name,node)",
        }
      : undefined,
    {
      ...config,
      skip: !params?.gym || !params?.customer,
    },
  );
}
